import { createAction, props } from '@ngrx/store';
import { Transfer } from '@app/shared/models/transfer';
import { ListTeamUserTransfersOutput } from '@smash-sdk/transfer/ejs/01-2024';


export const loadTransfersDeleted = createAction(
  '[TransfersDeleted] Load Transfers Deleted',
);

export const loadTransfersDeletedSuccess = createAction(
  '[TransfersDeleted] Load Transfers Deleted Success',
  props<{ transfers: (ListTeamUserTransfersOutput['transfers'][0] & { team: string, receiversNumber: number, sender: string, receiverEmails: string, type: string })[] }>()
);

export const loadTransfersDeletedFailure = createAction(
  '[TransfersDeleted] Load Transfers Deleted Failure',
  props<{ error: string }>()
);

export const loadTransfer = createAction(
  '[TransfersDeleted] Load Transfer',
  props<{ transferId: string }>()
);

